// imports section Start
import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  TextField,
  Button,
  Stack,
  Breadcrumbs,
  Link,
  AppBar,
} from "@mui/material";
import AddToolbar from "../../components/common/AddToolbar";
import { useSelector, useDispatch } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { SETTINGS_API_11 } from "../../api/ApiModel";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import Slide from "@mui/material/Slide";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
// imports section End

const Memberships = () => {
  // Hooks start
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState(null);
  const [error, setError] = useState({});
  const location = useLocation();
  const isEdit = location.state?.actionText === "Edit";
  const { selectedItem } = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    MEMBERSHIPCODE: "",
    GROUPNAME: "",
    DISCOUNT: "",
    AMOUNTFORPOINTS: "",
    POINTSFORAMOUNT: "",
    POINTSTOAMOUNT: "",
    AMOUNTTOPOINTS: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};

  // Handlers start

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Clear the error for the specific field when the user starts typing
    if (error[name]) {
      setError((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }

    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
    setError({ ...error, [name]: "" });
  };

  const handleConfirmClick = async () => {
    const {
      GROUPNAME,
      DISCOUNT,
      AMOUNTFORPOINTS,
      POINTSFORAMOUNT,
      POINTSTOAMOUNT,
      AMOUNTTOPOINTS,
    } = selectedItemDetails;

    const requiredFields = [
      { name: "GROUPNAME", value: GROUPNAME, label: " Name" },
      { name: "DISCOUNT", value: DISCOUNT, label: "Discount" },
      {
        name: "AMOUNTFORPOINTS",
        value: AMOUNTFORPOINTS,
        label: "Amount for Points",
      },
      {
        name: "POINTSFORAMOUNT",
        value: POINTSFORAMOUNT,
        label: "Points for Amount",
      },
      {
        name: "POINTSTOAMOUNT",
        value: POINTSTOAMOUNT,
        label: "Points to Amount",
      },
      {
        name: "AMOUNTTOPOINTS",
        value: AMOUNTTOPOINTS,
        label: "Amount to Points",
      },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );

    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });

      setError(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return;
    }

    if (data) {
      const isDuplicate = data.some((item) => {
        if (
          item.MEMBERSHIPCODE != selectedItemDetails.MEMBERSHIPCODE &&
          item.GROUPNAME === GROUPNAME
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setSnackbarMessage(" Name already exists."); // Show snackbar if duplicate found
        setOpenErrorSnackbar(true);
        return;
      }
    }

    const membershipcode = selectedItem
      ? String(selectedItem.MEMBERSHIPCODE || "")
      : "";

    const staticValues = {
      COMPCODE,
      LOCCODE,
      STS: CON_STATUS_ACTIVE,
      Enuser: USERNAME,
      LOCDATE: new Date().toISOString(),
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      MEMBERSHIPCODE: membershipcode,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_11, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        MEMBERSHIPCODE: "",
        GROUPNAME: "",
        DISCOUNT: "",
        AMOUNTFORPOINTS: "",
        POINTSFORAMOUNT: "",
        POINTSTOAMOUNT: "",
        AMOUNTTOPOINTS: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }
    setTimeout(() => {
      navigate("/vmembership");
    }, 2000);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      GROUPNAME: "",
      DISCOUNT: "",
      AMOUNTFORPOINTS: "",
      POINTSFORAMOUNT: "",
      POINTSTOAMOUNT: "",
      AMOUNTTOPOINTS: "",
    });
    setError({});
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  const handleInputValidation = (event) => {
    const { name, value } = event.target;

    // Allow only letters and spaces
    const regex = /^[a-zA-Z0-9\s]*$/;

    if (regex.test(value)) {
      handleInputChange(event);
    } else {
      setError({
        ...error,
        [name]: "Only Letters,Numbers and spaces are allowed.",
      });
    }
  };

  const handlenumInputValidation = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow only numbers and floats
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value)) {
      handleInputChange(event);
    } else {
      setError({ ...error, [name]: "Only numbers and floats are allowed." });
    }
  };

  const handleDiscountValidation = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow numbers with up to two decimal points
    const regex = /^(100(\.0{0,2})?|[0-9]{1,2}(\.[0-9]{0,2})?)?$/;

    // Check if the value is a valid number and does not exceed 100
    if (regex.test(value)) {
      if (value === "" || parseFloat(value) <= 100) {
        handleInputChange(event);
        setError({ ...error, [name]: "" }); // Clear error on valid input
      } else {
        setError({
          ...error,
          [name]: "Value must be between 0 and 100.",
        });
      }
    } else {
      setError({
        ...error,
        [name]: "Only numbers up to two decimal places are allowed.",
      });
    }
  };

  const gotToView = () => {
    navigate("/vmembership");
  };

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        MEMBERSHIPCODE: selectedItem.MEMBERSHIPCODE,
        GROUPNAME: selectedItem.GROUPNAME,
        DISCOUNT: String(selectedItem.DISCOUNT),
        AMOUNTFORPOINTS: String(selectedItem.AMOUNTFORPOINTS),
        POINTSFORAMOUNT: String(selectedItem.POINTSFORAMOUNT),
        POINTSTOAMOUNT: String(selectedItem.POINTSTOAMOUNT),
        AMOUNTTOPOINTS: String(selectedItem.AMOUNTTOPOINTS),
      });
    }
  }, [selectedItem]);

  // Handlers end

  // API calls start

  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_11, "get", {
        COMPCODE,
        LOCCODE,
        STS: CON_STATUS_ACTIVE,
      });
      setData(result);
    } catch (err) {
      setError(err);
    } finally {
    }
  };
  // API calls end

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Customer</Link>
                <Link underline="none">Membership</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{ name: isEdit ? "Edit Membership" : "Create Membership" }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid container item spacing={2} xs={12} sm={12} md={6} lg={6}>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Membership Name"
                size="small"
                fullWidth
                required
                variant="outlined"
                autoComplete="off"
                name="GROUPNAME"
                value={selectedItemDetails.GROUPNAME}
                onChange={handleInputValidation}
                error={!!error.GROUPNAME}
                helperText={error.GROUPNAME}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Discount"
                size="small"
                fullWidth
                required
                variant="outlined"
                autoComplete="off"
                name="DISCOUNT"
                value={selectedItemDetails.DISCOUNT}
                onChange={handleDiscountValidation}
                error={!!error.DISCOUNT}
                helperText={error.DISCOUNT}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Earning Amount"
                size="small"
                fullWidth
                required
                variant="outlined"
                autoComplete="off"
                name="AMOUNTFORPOINTS"
                value={selectedItemDetails.AMOUNTFORPOINTS}
                onChange={handlenumInputValidation}
                error={!!error.AMOUNTFORPOINTS}
                helperText={error.AMOUNTFORPOINTS}
              />
            </Grid>
          </Grid>
          <Grid container item spacing={2} xs={12} sm={12} md={6} lg={6}>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Earning Points "
                size="small"
                fullWidth
                required
                variant="outlined"
                autoComplete="off"
                name="POINTSFORAMOUNT"
                value={selectedItemDetails.POINTSFORAMOUNT}
                onChange={handlenumInputValidation}
                error={!!error.POINTSFORAMOUNT}
                helperText={error.POINTSFORAMOUNT}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Paying Amount  "
                size="small"
                fullWidth
                required
                variant="outlined"
                autoComplete="off"
                name="AMOUNTTOPOINTS"
                value={selectedItemDetails.AMOUNTTOPOINTS}
                onChange={handlenumInputValidation}
                error={!!error.AMOUNTTOPOINTS}
                helperText={error.AMOUNTTOPOINTS}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Paying Points "
                size="small"
                fullWidth
                required
                variant="outlined"
                autoComplete="off"
                name="POINTSTOAMOUNT"
                value={selectedItemDetails.POINTSTOAMOUNT}
                onChange={handlenumInputValidation}
                error={!!error.POINTSTOAMOUNT}
                helperText={error.POINTSTOAMOUNT}
              />
            </Grid>
          </Grid>
        </Grid>
        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? " Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={6000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default Memberships;
